import { render, staticRenderFns } from "./ProPatientsAPage.vue?vue&type=template&id=45453886"
import script from "./ProPatientsAPage.vue?vue&type=script&lang=js"
export * from "./ProPatientsAPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports